export default __webpack_public_path__ + "static/aromatherapy-3eae30b052298caddc517ae499519e22.jpg";